
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Mail, AlertTriangle } from 'lucide-react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  email?: string;
  emailDeliveryIssue?: boolean;
}

const ConfirmationModal = ({ isOpen, onClose, email, emailDeliveryIssue = false }: ConfirmationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="h-5 w-5 text-blue-dark" />
            Confirme seu email
          </DialogTitle>
          <DialogDescription>
            Enviamos um link de confirmação para
            {email ? (
              <span className="font-medium text-blue-dark"> {email}</span>
            ) : (
              ' seu email'
            )}.
            Por favor, verifique sua caixa de entrada (ou spam) e clique no link para ativar sua conta.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center py-4">
          <div className={`${emailDeliveryIssue ? "bg-yellow-50" : "bg-blue-50"} p-4 rounded-lg text-center`}>
            {emailDeliveryIssue ? (
              <div className="flex flex-col items-center text-yellow-700">
                <AlertTriangle className="h-5 w-5 mb-2" />
                <p className="text-sm">
                  Detectamos um possível problema com o envio do email de confirmação. 
                  Por favor, entre em contato com o suporte se não receber o email em alguns minutos.
                </p>
              </div>
            ) : (
              <p className="text-sm text-gray-600">
                Não recebeu o email? Verifique sua pasta de spam ou tente novamente.
              </p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onClose} className="w-full">
            Entendi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
